module.exports = __webpack_public_path__ + "img/light.8a03ff8a.png";